export const AI_VISIBILITY_DETAIL_TABS = [
  {
    key: 'overview',
    label: 'Overview',
    routeName: 'AiVisibilityOverview',
    tag: 'AI Tracker - Live',
    title: 'Your brand in AI answers',
    description: "When someone asks ChatGPT or any other LLM about your industry, does your site come up? This dashboard tracks exactly that - every question, every mention, every week - and shows you where competitors are winning.",
    showLegend: true,
    filters: ['range', 'model'],
  },
  {
    key: 'citations',
    label: 'Citations',
    routeName: 'AiVisibilityCitations',
    tag: 'Citations',
    title: 'Where AI learned about your space',
    description: 'When AI answers questions about your industry, it reads a handful of websites first. These are those websites - ranked by how often AI relied on them. Pages where AI cited a competitor but skipped you are your best opportunities.',
    showLegend: false,
    filters: ['range', 'model'],
  },
  {
    key: 'competitors',
    label: 'Competitors',
    routeName: 'AiVisibilityCompetitors',
    tag: 'Competitors',
    title: 'Who AI recommends instead of you',
    description: 'These are the brands AI mentions in its answers to your tracked questions. The ones flagged "Beats you" are winning - see where and why, then fix it.',
    showLegend: false,
    filters: ['range', 'model'],
  },
  {
    key: 'questions',
    label: 'Questions',
    routeName: 'AiVisibilityQuestions',
    tag: 'Questions',
    title: 'The questions your customers are asking AI',
    description: "These are real questions people ask ChatGPT and Google's AI about your space. For each one, we check whether you're in the answer - and if not, who got your spot. Fix the reds first.",
    showLegend: false,
    showManageQuestionsAction: true,
    filters: ['range', 'model'],
  },
]
